module.exports = __webpack_public_path__ + "static/ja-e64c801aeb5d3a74a84fc06df5d13df1.png";